export const URI_ORGANIZATION = "/api/organization";
export const URI_ORGANIZATION_ADD = "/api/organization";
export const URI_ORGANIZATION_DELETE = "/api/organization/:id";
export const URI_ORGANIZATION_EDIT = "/api/organization/:id";
export const URI_ORGANIZATION_FORM = "/api/organization/:id/form";
